import { Component } from '@angular/core';
import { Tecnico } from '../../domains/tecnico';
import { Pagamento } from '../../domains/pagamento';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../auth/auth.service';
import { Result } from '../../domains/result';
import { environment } from '../../../environments/environment';
import { Periodo } from '../../domains/periodo';
import { Cliente } from '../../domains/cliente';
import { Filial } from '../../domains/filial';
import { forkJoin, Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-pagamento-list',
  templateUrl: './pagamento-list.component.html',
  styleUrl: './pagamento-list.component.scss',
})
export class PagamentoListComponent {
  tecnicos: Tecnico[] = [];
  pagamentos: Pagamento[] = [];
  periodos: Periodo[] = [];
  clientes: Cliente[] = [];
  filiais: Filial[] = [];
  cloned: { [s: string]: Pagamento } = {};
  showList = false;

  minDate = new Date();

  constructor(
    private http: HttpClient,
    private router: Router,
    private messageService: MessageService,
    private authorizeService: AuthService
  ) {}
  ngOnInit() {
    const observers: Observable<any>[] = [];

    let obs: Observable<any> = this.http.get<Result<Tecnico[]>>(
      environment.apiUrl + '/technician'
    );
    obs.subscribe(
      (res) => {
        if (res.data.length < 2) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Você não tem permissão!',
          });
          this.router.navigate(['/atendimento']);
        } else {
          this.tecnicos = res.data;
        }
      },
      (error) => {
        console.log(error);
        if (error.status === 401) {
          this.authorizeService.logout();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Não foi possível carregar os tecnicos',
          });
        }
      }
    );
    observers.push(obs);

    obs = this.http.get<Result<Periodo[]>>(environment.apiUrl + '/period');
    obs.subscribe(
      (res) => {
        if (res.success) {
          this.periodos = res.data;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Ocorreu um eror na listagem de periodos!',
          });
        }
      },
      (error) => {
        console.log(error);
        if (error.status === 401) {
          this.authorizeService.logout();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Não foi possível carregar os periodos',
          });
        }
      }
    );
    observers.push(obs);

    obs = this.http.get<Result<Cliente[]>>(environment.apiUrl + '/customers');
    obs.subscribe(
      (res) => {
        if (res.success) {
          this.clientes = res.data;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Ocorreu um eror na listagem de clientes!',
          });
        }
      },
      (error) => {
        console.log(error);
        if (error.status === 401) {
          this.authorizeService.logout();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Não foi possível carregar os clientes',
          });
        }
      }
    );
    observers.push(obs);

    obs = this.http.get<Result<Filial[]>>(environment.apiUrl + '/branch');
    obs.subscribe(
      (res) => {
        if (res.success) {
          this.filiais = res.data;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Ocorreu um eror na listagem de filiais!',
          });
        }
      },
      (error) => {
        console.log(error);
        if (error.status === 401) {
          this.authorizeService.logout();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Não foi possível carregar as filiais',
          });
        }
      }
    );
    observers.push(obs);

    // Wait for all observables to complete before proceeding
    forkJoin(observers).subscribe(() => {
      this.getPagamentos();
    });
  }

  openNew() {
    this.showList = false;
    this.pagamentos.unshift({
      id: 0,
      valor: 0,
      saldo: 1,
      chave_pix: '',
      status_banco: undefined as any,
      filial_id: undefined,
      tecnico_id: undefined,
      periodo_id: undefined,
    });
    setTimeout(() => {
      this.showList = true;
    }, 2);
  }

  checaPagamentos() {
    this.http
      .get<Result<Pagamento[]>>(environment.apiUrl + '/paymentCheck')
      .subscribe(
        (res) => {
          if (res.success) {
            this.pagamentos = res.data;
            this.showList = true;
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Ocorreu um eror na checagem de pagamentos!',
            });
          }
        },
        (error) => {
          console.log(error);
          if (error.status === 401) {
            this.authorizeService.logout();
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Não foi possível checar os pagamentos',
            });
          }
        }
      );
  }

  getPagamentos() {
    this.http
      .get<Result<Pagamento[]>>(environment.apiUrl + '/payment')
      .subscribe(
        (res) => {
          if (res.success) {
            this.pagamentos = res.data;
            this.showList = true;
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Ocorreu um eror na listagem de pagamentos!',
            });
          }
        },
        (error) => {
          console.log(error);
          if (error.status === 401) {
            this.authorizeService.logout();
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Não foi possível carregar os pagamentos',
            });
          }
        }
      );
  }

  onRowEditInit(pagamento: Pagamento) {
    this.cloned[pagamento.id as any] = { ...pagamento };
  }

  onRowEditSave(pagamento: Pagamento) {
    let obs;
    const _pagamento: any = { ...pagamento };
    delete _pagamento['cliente_id'];
    _pagamento['envia_banco'] = true;

    if (_pagamento.id) {
      obs = this.http.put<Result<Pagamento>>(
        environment.apiUrl + '/payment/' + _pagamento.id,
        _pagamento
      );
    } else {
      obs = this.http.post<Result<Pagamento>>(
        environment.apiUrl + '/payment',
        _pagamento
      );
    }

    obs.subscribe(
      () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Pagamento Atualizado',
        });
        this.cloned = {};
        this.getPagamentos();
      },
      (error) => {
        console.log(error);

        if (error.status === 401) {
          this.authorizeService.logout();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Pagamento não atualizado',
          });
        }
      }
    );
  }

  onRowEditCancel(pagamento: Pagamento, index: number) {
    this.pagamentos[index] = this.cloned[pagamento.id as any];
    delete this.cloned[pagamento.id as any];
  }

  onDelete(pagamento: Pagamento) {
    if (pagamento.id) {
      const url = environment.apiUrl + '/payment/' + pagamento.id;
      this.http.delete<Pagamento[]>(url).subscribe(
        () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Pagamento excluído',
          });
          this.getPagamentos();
        },
        (error) => {
          console.log(error);
          if (error.status === 401) {
            this.authorizeService.logout();
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Pagamento não excluído',
            });
          }
        }
      );
    } else {
      this.pagamentos = this.pagamentos.filter((x) => {
        return x !== pagamento;
      });
    }
  }

  periodosCliente(id: number) {
    return this.periodos.filter((x) => {
      return x.cliente_id === (id as any);
    });
  }

  nomeTecnico(id: number) {
    const tecnico = this.tecnicos.find((x) => x.id === id);
    return tecnico ? tecnico.nome : '-';
  }
  nomeCliente(id: number) {
    const periodo = this.periodos.find((x) => x.id === id);
    if (periodo) {
      const cliente = this.clientes.find(
        (x) => (x.id as any) === periodo.cliente_id
      );
      return cliente ? cliente.nome : '-';
    } else {
      return '-';
    }
  }
  idCliente(id: number) {
    const periodo = this.periodos.find((x) => x.id === id);
    if (periodo) {
      const cliente = this.clientes.find(
        (x) => (x.id as any) === periodo.cliente_id
      );
      return cliente ? cliente.id : undefined;
    } else {
      return undefined;
    }
  }
  nomePeriodo(id: number) {
    const periodo = this.periodos.find((x) => x.id === id);
    return periodo ? periodo.descricao : '-';
  }
  nomeFilial(id: number) {
    const filial = this.filiais.find((x) => x.id === id);
    return filial ? filial.nome : '-';
  }
  onChangeTecnico(id: number, pagamento: Pagamento) {
    const tecnico = this.tecnicos.find((x) => x.id === id);
    if (tecnico) {
      pagamento.chave_pix = tecnico.chave_pix;
    }
  }

  getSeverity(
    status: string
  ):
    | 'success'
    | 'secondary'
    | 'info'
    | 'warn'
    | 'danger'
    | 'contrast'
    | undefined {
    switch (status) {
      case 'CRIADO':
      case 'AGUARDANDO_APROVACAO':
        return 'info';
      case 'APROVADO':
      case 'PAGO':
      case 'DEBITADO':
        return 'success';
      case 'REPROVADO':
      case 'EXPIRADO':
      case 'CANCELADO':
      case 'FALHA':
      case 'CANCELADO_SEM_SALDO':
      case 'NAO_DEBITADO':
      case 'AGENDAMENTO_CANCELADO':
        return 'danger';
      case 'AGENDADO':
      case 'ENVIADO':
      case 'PARCIALMENTE_DEBITADO':
      case 'PARCIALMENTE_PAGO':
        return 'warn';
      default:
        return 'secondary'; // Caso o status não seja reconhecido
    }
  }
}
